import type { ReactNode } from 'react'
import { View } from 'react-native'

import { cn } from '@/utils/cn'

interface ScreenHeaderProps {
  leftElement?: ReactNode
  centerElement?: ReactNode
  rightElement?: ReactNode
  hasBottomBorder?: boolean
}

export default function ScreenHeader({
  leftElement,
  centerElement,
  rightElement,
  hasBottomBorder = false
}: ScreenHeaderProps) {
  return (
    <View className={cn('h-11 px-2', hasBottomBorder && 'border-b border-border-10')}>
      <View className={'relative size-full flex-row items-stretch justify-center'}>
        <View className={'absolute left-0 h-full flex-row items-center gap-3'}>{leftElement}</View>
        <View className={'absolute h-full flex-row items-center gap-3'}>{centerElement}</View>
        <View className={'absolute right-0 h-full flex-row items-center gap-1'}>{rightElement}</View>
      </View>
    </View>
  )
}
